/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const CSS = {
  title: "title",
  close: "close",
  imageContainer: "image-container",
  chipIcon: "chip-icon",
  textSlotted: "text--slotted",
  container: "container",
  imageSlotted: "image--slotted",
  closable: "closable",
  multiple: "multiple",
  single: "single",
  selectable: "selectable",
  selectIcon: "select-icon",
  selectIconActive: "select-icon--active",
  nonInteractive: "non-interactive",
  isCircle: "is-circle",
  selected: "selected"
};
const SLOTS = {
  image: "image"
};
const ICONS = {
  close: "x",
  checkedSingle: "circle-f",
  uncheckedMultiple: "square",
  checkedMultiple: "check-square-f"
};
function isChip(el) {
  return el?.tagName === "CALCITE-CHIP";
}
export {
  CSS as C,
  ICONS as I,
  SLOTS as S,
  isChip as i
};
